import styles from './skeletons.module.css';

/**
 * Phase 5 PR 5.1 — placeholder for `<ChampionshipCard />` while
 * `useUpcomingRace` resolves.
 *
 * Renders a dark card matching ChampionshipCard dimensions with the
 * top row, title, and phase track stubbed out as neutral bars.
 *
 * W1-TODAY-WIRE (2.0 cold-load gate): `decorative` drops the status role and the
 * name, so the desktop rail can hold its place beside `TodaySkeletonV2` (the one
 * "Loading today" status) without a second announcement. Absent = unchanged.
 */
export function ChampionshipCardSkeleton({ decorative = false }: { decorative?: boolean } = {}) {
  return (
    <section
      className={styles.champ}
      {...(decorative
        ? { 'aria-hidden': true }
        : { role: 'status', 'aria-busy': 'true', 'aria-label': 'Loading next race' })}
    >
      <div className={styles.champTop}>
        <div className={styles.champTopLeft}>
          <span className={`${styles.bar} ${styles.dark} ${styles.champMicro}`} aria-hidden />
          <span className={`${styles.bar} ${styles.dark} ${styles.champTitle}`} aria-hidden />
        </div>
        <span className={`${styles.bar} ${styles.dark} ${styles.champArrow}`} aria-hidden />
      </div>
      <span className={`${styles.bar} ${styles.dark} ${styles.champTrack}`} aria-hidden />
    </section>
  );
}
